import { axios, createFormData, handleError } from '../axios';

export const addGCategory = (data) => {
  return new Promise((resolve) => {
    axios
      .post('admin/g_category/add', createFormData(data))
      .then((response) => {
        try {
          resolve(response.data);
        } catch (e) {
          console.error(e.message);
        }
      })
      .catch((e) => {
        handleError(e);
      });
  });
};
